class CourseActions {

    static courses = "COURSES";    
    static coursesSuccess = "COURSES_SUCCESS";
    static coursesFailed = "COURSES_FAILED";

    static joinCourse = "JOIN_COURSE";
    static joinCourseSuccess = "JOIN_COURSE_SUCCESS";
    static joinCourseFailed = "JOIN_COURSE_FAILED";

    static modules = "MODULES";
    static modulesSuccess = "MODULES_SUCCESS";
    static modulesFailed = "MODULES_FAILED";

    static quizInfo = "QUIZ_INFO";
    

    static Courses(data) {
        return {
            type : this.courses,
        }
    }

    static CoursesSuccess(data) {
        return {
            type : this.coursesSuccess,
            data : data
        }
    }

    static CoursesFailed(data) {
        return {
            type : this.coursesFailed,
        }
    }

    static JoinCourse(data) {
        return {
            type : this.joinCourse,
        }
    }

    static JoinCourseSuccess(data) {
        return {
            type : this.joinCourseSuccess,
            data : data
        }
    }

    static JoinCourseFailed(data) {
        return {
            type : this.joinCourseFailed,
        }
    }
    
    static Modules(data) {
        return {
            type : this.modules,
        }
    }

    static ModulesSuccess(data) {
        return {
            type : this.modulesSuccess,
            data : data
        }
    }

    static ModulesFailed(data) {
        return {
            type : this.modulesFailed,
        }
    }

    static QuizInfo(data) {
        return {
            type : this.quizInfo,
            data : data

        }
    }
    
    static ClearModule(){
        return {
            type : this.clearModule,
        }
    }

}

export default CourseActions;


// WEBPACK FOOTER //
// ./src/store/actions/courseActions.js